import { render } from "./JalizbanChart.vue?vue&type=template&id=7c54397b"
import script from "./JalizbanChart.vue?vue&type=script&lang=js"
export * from "./JalizbanChart.vue?vue&type=script&lang=js"

import "./JalizbanChart.vue?vue&type=style&index=0&id=7c54397b&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__